import type { PropsWithChildren } from 'react';
import { createContext, useState } from 'react';

import noop from 'lodash/noop';

export interface MedicationCardState {
  showRefillRequestedToastBanner?: boolean;
  prescriptionIdsInRequestRefillState: string[];
  prescriptionIdsInProcessRefillState: string[];
  patientMedicationIdInRequestRefillState?: number | null;
  patientMedicationIdInProcessRefillState?: number | null;
  refillRequestTimeoutId?: NodeJS.Timeout | null;
  source?: string | null;
}

export type MedicationCardContextType = {
  medicationCardState: MedicationCardState;
  saveMedicationCardState: (medicationCardState: MedicationCardState) => void;
};

export const MedicationCardStateContext = createContext<MedicationCardContextType>({
  medicationCardState: {
    prescriptionIdsInRequestRefillState: [],
    prescriptionIdsInProcessRefillState: [],
  },
  saveMedicationCardState: noop,
});

const MedicationCardStateProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [medicationCardState, setMedicationCardState] = useState<MedicationCardState>({
    showRefillRequestedToastBanner: false,
    prescriptionIdsInRequestRefillState: [],
    prescriptionIdsInProcessRefillState: [],
    patientMedicationIdInRequestRefillState: null,
    refillRequestTimeoutId: null,
    source: null,
  });
  const saveMedicationCardState = (newMedicationCardState: MedicationCardState) => {
    setMedicationCardState({ ...medicationCardState, ...newMedicationCardState });
  };
  return (
    <MedicationCardStateContext.Provider value={{ medicationCardState, saveMedicationCardState }}>
      {children}
    </MedicationCardStateContext.Provider>
  );
};

export default MedicationCardStateProvider;
